export const environment = {
  production: false,
  apiUrl: 'https://api.asone.global',
  apiKey: 'G37BF2948D54BB2A5CEF4D1BD3F3CA3123',
  asoneUrl: 'https://www.asone.global/csp/asone/REST/api/',
  asoneGlobalUrl: 'https://api.asone.global/api/BizzBean/v1/relay/',
  appInsights: {
    instrumentationKey: 'bed88e09-b244-4c0e-bf0d-7531c963b409',
  },
  static_image_url: 'https://api.streamline.bizzcapital.net',
  // static_image_url: 'http://127.0.0.1:8000',
  XKEY_static_files: '0OD67Sv6TXXAKnmvr6RJmOLj80n4iAuq',
};

// https://api.asone.global/api/BizzBean/v1/relay/BBsetup1 : Hits Andre systme
